import { Button, Group } from '@mantine/core'

export const SubmitButton = ({
  label,
  loading,
}: {
  label: string
  loading?: boolean
}) => (
  <Group justify="center">
    <Button type="submit" loading={loading}>
      {label}
    </Button>
  </Group>
)
